import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import Meta from "vue-meta";
import VueAnalytics from "vue-analytics";
import VueMeta from 'vue-meta'
// import VuetifyDaterangePicker from "vuetify-daterange-picker";
// import "vuetify-daterange-picker/dist/vuetify-daterange-picker.css";



Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'GTM-K36DNJ8',
  router
});

export const bus = new Vue();
new Vue({
  router,
  vuetify,
  Meta,
  VueMeta,
  render: h => h(App)
}).$mount('#app')
